var redirecting = false;
if (typeof sessionStorage.apitoken === "undefined") {
  redirecting = true;
  let currentUrl =
    window.location.pathname + window.location.search + window.location.hash;
  window.location.href = "/login/?r=" + encodeURIComponent(currentUrl);
}

module.exports = redirecting;